export default __webpack_public_path__ + "static/media/Ficha_maiz_EN.8bd36ac4.png";